import React,{useState} from 'react'
import NormalInput from "../../Components/common/input/NormalInput";
import { commonInsertWithPost } from '../../Utils/APIs/commonInsertWithPost';
const UploadInvoice = () => {
    const [saralId, setSaralId] = useState(null);
    const [file, setFile] = useState(null);
    const [isDisable, setIsDisable] = useState(false);
    const handleSubmit = async(e) => {
    e.preventDefault();
    if (!file) {
      alert("Please upload a PDF file");
      return;
    }
    if (file.type !== "application/pdf") {
      alert("Only PDF files are allowed");
      return;
    }
    setIsDisable(true)
    const formData = new FormData();
    formData.append("saralId", saralId);
    formData.append("file", file);
    const response = await commonInsertWithPost("/farmer/uploadInvoice", formData);
    if(response.success){
        setFile(null);
        setSaralId(null);
        alert(response.message);
    }else{
        alert(response.message);
    }
    setIsDisable(false)
  };
  return (
    <div className="flex w-full h-full flex-col">
      <div className="mainHeading">
        <h1 className="text-3xl font-semibold tracking-widest text-center p-2 bg-gray-50  rounded-lg">
          I<span className="text-lg">NVOICE</span> U
          <span className="text-lg">PLOAD</span>
        </h1>
      </div>
      <form onSubmit={handleSubmit} className='flex gap-8 items-center justify-center'>
      {/* Text Input */}
      <NormalInput
          label="Saral Id"
          value={saralId}
          setterFun={setSaralId}
          isRequired={true}
          placeholder="Write Saral Id "
        />
        <NormalInput
          type="file"
          label="Invoice"
          value={file}
          setterFun={setFile}
          isRequired={true}
          
        />
      <button type="submit" className='bg-blue-600 text-white h-10 rounded-sm mt-7 px-2' disabled={isDisable}>{!isDisable ? "Submit" : "Loading..."}</button>
    </form>
    </div>
  )
}
export default UploadInvoice